

import Link from 'next/link';
import { useEffect, useRef, useState } from 'react';
import moment from 'moment';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import { getBLogs } from '../../redux/actions/blog';
import Head from 'next/head';
import Device from '../Device';
import MetaSeo from '../MetaSeo';
import dynamic from 'next/dynamic';
import ImageOutput from '@/components/Editor/image';
import { useRouter } from 'next/router';

const Output = dynamic(
    () => import('editorjs-react-renderer'),
    { ssr: false }
);
const renderers = {
    image: ImageOutput
};

export default function detail(props) {
    const dispatch = useDispatch();
    const [post_category, setPostCategory] = useState([]);
    const [total, setTotal] = useState(0);
    const [search, setSearch] = useState('');
    const [page, setPage] = useState(1);
    const router = useRouter();
    const { news } = useSelector(state => {
        return {
            news: state.news.news,
        };
    }, shallowEqual);
    useEffect(() => {

        if (props.postcategory) {
            getPostCategory();
        }
        setPage(1);

    }, [dispatch, props]);
    const getPostCategory = async () => {
        const data = await getBLogs({ category_id: props.postcategory.id, id: props.id }, dispatch);
        if (data) {
            setPostCategory(data.rows);
            setTotal(data.total);
        }
    };
    const loadMore = async () => {
        let new_page = parseInt(page) + 1;
        setPage(new_page);
        const data = await getBLogs({ page: new_page, limit: 3, category_id: props.postcategory.id, id: props.id }, dispatch);

        if (data) {
            const new_data = [...post_category, ...data.rows];
            setPostCategory(new_data);
        }
    };
    const filterTag = async (tag_name) => {
        let new_search = `#${tag_name}`;
        setSearch(new_search);
        const data = await getBLogs({ name: new_search, page: 1, category_id: props.postcategory.id, id: props.id }, dispatch);
        setPage(1);
        setTotal(data.total);
        setPostCategory(data.rows);
    };

    const defaultConfigs = {
        header: {
            textAlign: 'left',
        },
        image: {
            img: {
            },
            figure: {
                backgroundColor: 'aliceblue',
                border: '1px solid #eee'
            },
            figcaption: {
                borderRadius: '5px',
            }
        },
        video: {
            video: {
            },
            figure: {
                backgroundColor: 'aliceblue',
                border: '1px solid #eee'
            },
            figcaption: {
                borderRadius: '5px',
            }
        },
        embed: {
            video: {
            },
            figure: {
                justifyContent: 'center',
            },
            figcaption: {
                borderRadius: '5px',
            }
        },
        paragraph: {
            textAlign: 'left',
            cursor: 'default',
        },
        list: {
            textAlign: 'left',
        },
        checklist: {
            container: {},
            item: {},
            checkbox: {},
            label: {},
        },
        table: {
            table: {},
            tr: {},
            th: {},
            td: {},
        },
        quote: {
            container: {},
            content: {},
            author: {
                fontWeight: 'bold',
            },
            message: {
                textAlign: 'left',
            }
        },
        codeBox: {
            container: {
                width: '100%',
            },
            code: {
                boxSizing: 'border-box',
            },
        },
        warning: {
            container: {
                width: '100%',
            },
            icon: {
                width: '30px',
            },
            title: {
                fontWeight: 500
            },
            message: {
                fontSize: '14px'
            },
        },
        delimiter: {
            container: {},
            svg: {},
            path: {
                fill: '#231F20'
            }
        },
    };

    const dataSeo = {
        url: `${process.env.NEXT_PUBLIC_SEO_URL}/news/${props.seo_url}`,
        type: 'website',
        title: `${props.title} |  TCOM JAPAN`,
        description: props.seo_description || 'TCOM JAPAN',
        image: props.image,
        domain: process.env.NEXT_PUBLIC_DOMAIN,
        card: 'summary_large_image'
    };
    console.log('llll', props.html_content);
    return (
        <>
            <MetaSeo {...dataSeo} />
            <div id='news-details'>
                <div className='main-content'>
                    <div>
                        <div className='container'>
                            <div class='handleBtnBackNews'>
                                <a onClick={() => router.back()}>
                                    <svg width='25' height='24' viewBox='0 0 25 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
                                        <path d='M19.5 11.0013H7.64L11.27 6.64125C11.4397 6.43704 11.5214 6.17375 11.497 5.90933C11.4726 5.6449 11.3442 5.40099 11.14 5.23125C10.9358 5.06151 10.6725 4.97985 10.4081 5.00423C10.1437 5.02861 9.89974 5.15704 9.73 5.36125L4.73 11.3613C4.69636 11.409 4.66628 11.4591 4.64 11.5113C4.64 11.5613 4.64 11.5913 4.57 11.6413C4.52467 11.7559 4.50094 11.878 4.5 12.0013C4.50094 12.1245 4.52467 12.2466 4.57 12.3613C4.57 12.4113 4.57 12.4413 4.64 12.4913C4.66628 12.5434 4.69636 12.5935 4.73 12.6413L9.73 18.6413C9.82402 18.7541 9.94176 18.8449 10.0748 18.9071C10.2079 18.9694 10.3531 19.0015 10.5 19.0013C10.7337 19.0017 10.9601 18.9203 11.14 18.7713C11.2413 18.6873 11.325 18.5842 11.3863 18.4679C11.4477 18.3515 11.4855 18.2242 11.4975 18.0932C11.5096 17.9622 11.4957 17.8302 11.4567 17.7046C11.4176 17.579 11.3542 17.4623 11.27 17.3613L7.64 13.0013H19.5C19.7652 13.0013 20.0196 12.8959 20.2071 12.7084C20.3946 12.5208 20.5 12.2665 20.5 12.0013C20.5 11.736 20.3946 11.4817 20.2071 11.2941C20.0196 11.1066 19.7652 11.0013 19.5 11.0013Z' fill='#3E3C3C'></path>
                                    </svg>
                                    <span>戻る</span>
                                </a>
                            </div>
                            <h1 className='page-title'>{props?.title}</h1>
                            <div className='meta'>
                                <div className='date'>
                                    <img src='/assets/images/news-details/icon-calendar.png' alt='' />
                                    {moment(props?.show_date || props?.createdAt).format('YYYY/MM/DD')}
                                </div>
                                <div className='share'>
                                    <h3> シェア:</h3>
                                    <ul>
                                        <li className='facebook'>
                                            <a href={`https://www.facebook.com/sharer/sharer.php?u=${process.env.NEXT_PUBLIC_SEO_URL}/`} target='_blank'>
                                                <svg width={41} height={41} viewBox='0 0 41 41' fill='none' xmlns='http://www.w3.org/2000/svg'>
                                                    <circle cx='20.5' cy='20.9907' r={20} fill='#0381FA' />
                                                    <path d='M24.8772 13.4696H27.0732V9.64497C26.6943 9.59285 25.3914 9.47559 23.8739 9.47559C20.7078 9.47559 18.5388 11.4671 18.5388 15.1274V18.496H15.0449V22.7717H18.5388V33.5301H22.8225V22.7727H26.1751L26.7073 18.497H22.8215V15.5514C22.8225 14.3156 23.1553 13.4696 24.8772 13.4696Z' fill='white' />
                                                </svg>
                                            </a>
                                        </li>
                                        <li className='linkedin'>
                                            <a href={`https://www.linkedin.com/sharing/share-offsite/?url=${process.env.NEXT_PUBLIC_SEO_URL}/`} target='_blank'>
                                                <svg width={41} height={41} viewBox='0 0 41 41' fill='none' xmlns='http://www.w3.org/2000/svg'>
                                                    <g clipPath='url(#clip0_628_2784)'>
                                                        <path d='M20.4999 0.990723C31.5462 0.990723 40.5 9.94572 40.5 20.9908C40.5 32.0359 31.5462 40.9907 20.4999 40.9907C9.45362 40.9907 0.5 32.0357 0.5 20.9908C0.5 9.94585 9.45376 0.990723 20.4999 0.990723Z' fill='#0077B4' />
                                                        <path d='M11.77 28.4707H15.5151V15.9881H11.77V28.4707ZM26.3601 15.5558C24.5426 15.5558 22.9163 16.2195 21.7627 17.6846V15.9471H18.0039V28.4708H21.7627V21.6983C21.7627 20.267 23.0739 18.8707 24.7164 18.8707C26.3589 18.8707 26.7639 20.267 26.7639 21.6633V28.4696H30.509V21.3846C30.5088 16.4632 28.1789 15.5558 26.3601 15.5558ZM13.6251 14.7407C14.6601 14.7407 15.5001 13.9007 15.5001 12.8656C15.5001 11.8306 14.6601 10.9907 13.6251 10.9907C12.59 10.9907 11.75 11.8308 11.75 12.8658C11.75 13.9008 12.59 14.7407 13.6251 14.7407Z' fill='white' />
                                                    </g>
                                                    <defs>
                                                        <clipPath id='clip0_628_2784'>
                                                            <rect width={40} height={40} fill='white' transform='translate(0.5 0.990723)' />
                                                        </clipPath>
                                                    </defs>
                                                </svg>
                                            </a>
                                        </li>
                                        <li className='twitter'>
                                            <a href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(`${process.env.NEXT_PUBLIC_SEO_URL}/`)}`} target='_blank'>
                                                <svg width={41} height={41} viewBox='0 0 41 41' fill='none' xmlns='http://www.w3.org/2000/svg'>
                                                    <circle cx='20.5' cy='20.9907' r={20} fill='#02CEFD' />
                                                    <path d='M34.4401 13.2525C33.4484 13.6875 32.3918 13.9758 31.2901 14.1158C32.4234 13.4392 33.2884 12.3758 33.6951 11.0942C32.6384 11.7242 31.4718 12.1692 30.2284 12.4175C29.2251 11.3492 27.7951 10.6875 26.2351 10.6875C23.2084 10.6875 20.7718 13.1442 20.7718 16.1558C20.7718 16.5892 20.8084 17.0058 20.8984 17.4025C16.3534 17.1808 12.3318 15.0025 9.6301 11.6842C9.15844 12.5025 8.88177 13.4392 8.88177 14.4475C8.88177 16.3408 9.85677 18.0192 11.3101 18.9908C10.4318 18.9742 9.5701 18.7192 8.8401 18.3175C8.8401 18.3342 8.8401 18.3558 8.8401 18.3775C8.8401 21.0342 10.7351 23.2408 13.2201 23.7492C12.7751 23.8708 12.2901 23.9292 11.7868 23.9292C11.4368 23.9292 11.0834 23.9092 10.7518 23.8358C11.4601 26.0008 13.4701 27.5925 15.8601 27.6442C14.0001 29.0992 11.6384 29.9758 9.08177 29.9758C8.63344 29.9758 8.20344 29.9558 7.77344 29.9008C10.1951 31.4625 13.0651 32.3542 16.1601 32.3542C26.2201 32.3542 31.7201 24.0208 31.7201 16.7975C31.7201 16.5558 31.7118 16.3225 31.7001 16.0908C32.7851 15.3208 33.6968 14.3592 34.4401 13.2525Z' fill='white' />
                                                </svg>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className='post'>
                                <div dangerouslySetInnerHTML={{ __html: props.html_content }} />
                                <div className='author'>編集者：TCOM</div>
                            </div>
                        </div>
                        <div className='r-news-list'>
                            <div className='container'>
                                {post_category ? (
                                    post_category.map((item, index) => (
                                        <div className='news-item'>
                                            <div className='row'>
                                                <div className='col-12 col-md-5'>
                                                    <Link href={`/news/${item.seo_url}`}>
                                                        <div className='img-new-left'>
                                                            <img style={{ maxHeight: 263, borderRadius: 15, width: 445, maxWidth: "100%", height: '100%', objectFit: 'cover' }} src={item.image} alt='' />
                                                        </div>
                                                    </Link>
                                                </div>
                                                <div className='col-12 col-md-7'>
                                                    <div className='content'>
                                                        <Link href={`/news/${item.seo_url}`}>
                                                            <a className='category'>{item?.postcategory?.name}</a>
                                                        </Link>
                                                        <Link href={`/news/${item.seo_url}`}><a className='title'>{item?.title}</a></Link>
                                                        <div className='date'>{moment(item?.show_date || item?.createdAt).format('YYYY/MM/DD')}</div>
                                                        <p className='content-news'>{item.html_content}</p>
                                                        <ul className='tag'>
                                                            {item.tag ? (
                                                                item.tag?.map((tag, index) => {
                                                                    return (
                                                                        <li key={index}>
                                                                            <a onClick={() => filterTag(tag.tag.name)}>{tag.tag.name}</a>
                                                                        </li>
                                                                    );
                                                                })
                                                            ) : null}

                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))

                                ) : null}
                                {post_category.length < total ? (
                                    <div className='text-center'>
                                        <a onClick={() => loadMore()} className='see-more'>続きを見る</a>
                                    </div>
                                ) : null}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    );
}